export default ({ request }) => ({
  billStockReturnMainStatisticsListApi(data = {}) {
    return request({
      url: '/samplemanage/billStockReturnMain/statistics/list',
      method: 'post',
      data,
    })
  },
})
